import { ChargeCardPaymentSourceOption } from '@varo/graphql-schema-types';
import React, { createContext, ReactElement, ReactNode, useState } from 'react';

interface BelieveMakePaymentProps {
  children: ReactNode;
}

interface BelieveMakePaymentContextProps {
  options: ChargeCardPaymentSourceOption[];
  setOptions: (options: ChargeCardPaymentSourceOption[]) => void;
  isPaymentDue: boolean;
  setPaymentDue: (isPaymentDue: boolean) => void;
  fullName: string;
  setFullName: (fullName: string) => void;
  isSecuredAccount: boolean;
  setIsSecuredAccount: (isSecuredAccount: boolean) => void;
}

export const BelieveMakePaymentContext =
  createContext<BelieveMakePaymentContextProps | null>(null);

export const BelieveMakePaymentProvider = ({
  children,
}: BelieveMakePaymentProps): ReactElement<BelieveMakePaymentProps> => {
  const [options, setOptions] = useState<ChargeCardPaymentSourceOption[]>([]);
  const [isPaymentDue, setPaymentDue] = useState(false);
  const [fullName, setFullName] = useState<string>('');
  const [isSecuredAccount, setIsSecuredAccount] = useState(false);
  return (
    <BelieveMakePaymentContext.Provider
      value={{
        options,
        setOptions,
        isPaymentDue,
        setPaymentDue,
        fullName,
        setFullName,
        isSecuredAccount,
        setIsSecuredAccount,
      }}
    >
      {children}
    </BelieveMakePaymentContext.Provider>
  );
};
